import { Typography } from '@munifocus/ui';
import type { ReactNode } from 'react';

/**
 * The line under the topbar saying what a screen is for.
 *
 * The topbar names the screen and carries its back arrow; it has no room to
 * explain itself. A form the officer lands on cold — intake especially — needs
 * one sentence on what it produces before the first field.
 */
export function PageIntro({ children }: { children: ReactNode }) {
  return (
    <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: '68ch' }}>
      {children}
    </Typography>
  );
}
